// src/pages/courtowner/CourtOwnerDashboard.js

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import CourtOwnerSidebar from "../../components/courtowner/CourtOwnerSidebar";
import { FaSearch, FaStar } from "react-icons/fa";
import gfiimage from "../../assets/logo0.png";
import "../../index.css";
const API_BASE = process.env.REACT_APP_API_BASE || "https://api.getfitindia.in/api";

function CourtOwnerDashboard() {
  const [venues, setVenues] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 🔹 Court Owner Name
  let ownerName = "Court Owner";
  try {
    const rawUser =
      localStorage.getItem("courtOwnerUser") || localStorage.getItem("user");
    if (rawUser) {
      const userObj = JSON.parse(rawUser);
      ownerName = userObj.businessName || userObj.name || "Court Owner";
    }
  } catch (e) {}

  // 🔹 Fetch venues
  useEffect(() => {
    const fetchVenues = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("courtOwnerToken");
        const res = await fetch(`${API_BASE}/courtowner/venues`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        setVenues(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error loading venues:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchVenues();
  }, []);

  // 🔍 Filter
  const filteredVenues = useMemo(() => {
    if (!search.trim()) return venues;
    const q = search.toLowerCase();
    return venues.filter((v) => {
      const name = (v.name || "").toLowerCase();
      const location =
        typeof v.location === "object"
          ? (v.location.address || "").toLowerCase()
          : (v.location || "").toLowerCase();
      return name.includes(q) || location.includes(q);
    });
  }, [search, venues]);

  // 🔁 Navigation
  const handleMyBookings = (venueId) =>
    navigate(`/courtowner/bookings/${venueId}`);
  const handleAllSlots = (venueId) =>
    navigate(`/courtowner/reports/all-slots/${venueId}`);

  // 🔹 Inline styles (unchanged part of UI)
  const styles = {
    greeting: { margin: "0 0 4px", fontSize: 15, color: "#555" },
    title: { margin: "0 0 14px", fontSize: 20, fontWeight: 700 },
    searchContainer: {
      backgroundColor: "#fff",
      height: 48,
      display: "flex",
      alignItems: "center",
      border: "1px solid #ddd",
      borderRadius: 30,
      paddingLeft: 14,
      paddingRight: 10,
    },
    cardGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
      gap: 20,
      marginTop: 8,
    },
    card: {
      background: "#fff",
      border: "1px solid #e3e3e3",
      borderRadius: 18,
      padding: 12,
      boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
      display: "flex",
      flexDirection: "column",
      height: "100%",
    },
    imageWrapper: {
      width: "100%",
      height: 210,
      borderRadius: 14,
      overflow: "hidden",
    },
    buttonsRow: {
      display: "flex",
      gap: 10,
      width: "100%",
      marginTop: 4,
    },
  };

 return (
  <div className="min-h-screen bg-[#f7f8fb]">

    {/* FIXED SIDEBAR LIKE YOUR SECOND CODE */}
    <aside className="hidden lg:block fixed inset-y-0 left-0 w-64 bg-white shadow z-30">
      <CourtOwnerSidebar />
    </aside>

    {/* MAIN AREA WITH LEFT PADDING FOR SIDEBAR */}
    <main className="lg:pl-64">

      {/* FULL-WIDTH STICKY HEADER (NO MARGIN / NO PADDING) */}
      <div className="bg-[#0f2250] text-white sticky top-0 z-20 w-full">
        <div className="px-4 py-4 flex items-center gap-0">

          {/* MOBILE SIDEBAR */}
          <div className="lg:hidden">
            <CourtOwnerSidebar />
          </div>
<img src={gfiimage} alt="GFI Logo" style={{ width: 54}} className="ms-2"/>
          {/* <h1 className="text-lg font-semibold uppercase  ">GET FIT INDIA</h1> */}

          <div className="ms-2 sm:ms-4 leading-none">
  <p className="font-bold cursor-pointer m-0 p-0" style={{fontSize:"unset",marginBottom:-7,textAlign: "-webkit-center",marginRight: 22}}>
    Get
  </p>

  <p className="text-2xl sm:text-3xl font-extrabold cursor-pointer m-0 p-0">
    Fit India
  </p>
</div>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="max-w-[1200px] mx-auto px-4 mt-6">

        <p style={styles.greeting}>Hello, {ownerName}!</p>
        <h4 style={styles.title}>{ownerName}'s Venues</h4>

        <div style={{ marginBottom: 14 }}>
          <div style={styles.searchContainer}>
            <FaSearch style={{ color: "#aaa", marginRight: 10 }} />
            <input
              type="text"
              placeholder="Search for Venue..."
              style={{ border: "none", flex: 1, outline: "none" }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {loading && <p>Loading venues...</p>}
        {!loading && filteredVenues.length === 0 && <p>No venues found.</p>}

        <div style={styles.cardGrid}>
          {filteredVenues.map((v) => (
            <div key={v._id} style={styles.card}>

              <div style={styles.imageWrapper}>
                <img
                  src={
                    v.image
                      ? `https://api.getfitindia.in/uploads/${v.image}?t=${Date.now()}`
                      : "/placeholder-ground.jpg"
                  }
                  alt={v.name}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  onError={(e) => {
                    e.target.src = "/placeholder-ground.jpg";
                  }}
                />
              </div>

              <h6 style={{ fontSize: 16, fontWeight: 600, marginTop: 10 }}>
                {v.name}
              </h6>

              <p style={{ fontSize: 13, color: "#666" }}>
                {v.location?.address || v.location || ""}
              </p>

              <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
                <div
                  style={{
                    width: 20,
                    height: 20,
                    borderRadius: 3,
                    backgroundColor: "#26a653",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    marginRight: 4,
                  }}
                >
                  <FaStar size={10} />
                </div>
                <span style={{ fontSize: 13 }}>
                  {typeof v.rating === "number" ? v.rating.toFixed(1) : "4.5"}
                </span>
              </div>

              <div style={styles.buttonsRow}>
                <button
                  onClick={() => handleMyBookings(v._id)}
                  style={{
                    flex: 1,
                    padding: "9px 0",
                    borderRadius: 20,
                    backgroundColor: "#fff",
                    color: "#043f6e",
                    border: "1px solid #043f6e",
                    fontSize: "12px",
                  }}
                >
                  MY BOOKINGS
                </button>

                <button
                  onClick={() => handleAllSlots(v._id)}
                  style={{
                    flex: 1,
                    padding: "9px 0",
                    borderRadius: 20,
                    backgroundColor: "#043f6e",
                    color: "#fff",
                    border: "1px solid #043f6e",
                    fontSize: "12px",
                  }}
                >
                  ALL SLOTS
                </button>
              </div>

            </div>
          ))}
        </div>

        <div style={{ height: 40 }} />
      </div>
    </main>
  </div>
);

}

export default CourtOwnerDashboard;
